module.exports = __webpack_public_path__ + "fonts/firacode-regular.9bb4ce9.ttf";